export const iconFontAwesomeArrowsRotate = (
	<i className="fa-solid fa-rotate"></i>
);
